<template>
  <div class="container">
    <div class="header">
      <van-icon
          class="header-return"
          name="arrow-left"
          size="25"
          color="#333333"
          @click="onClickHeaderReturn()"
      />
      Devices
    </div>
    <div class="content">
      <div class="grid grid-cols-2 gap-3 pl-4 pr-4">
        <Hub v-for="(item,index) in deviceList"
            :hub="item"
            :key="index"
            @onConnect="onClickConnectDevice(item,index)"/>
      </div>
      <ConnectStatusPopup :status="status" v-model="showConnectStatusPopup"/>
    </div>
  </div>
</template>

<script>
import Hub from "@/components/bt/Hub.vue";
import { mapState } from "vuex";
import ConnectStatusPopup from "@/components/bt/ConnectStatusPopup.vue";
import bluetoothRepository from "@/bluetooth/BluetoothRepository";

export default {
  name: "HubDevices",
  components: { ConnectStatusPopup, Hub },
  data() {
    return {
      status: 0,
      showConnectStatusPopup: false,
      timeoutId: 0
    };
  },
  methods: {
    onClickHeaderReturn() {
      this.$router.replace({ name: "BtHome" });
      // this.$router.go(-1);
    },

    async onClickConnectDevice(item, index) {
      if (item.gatt.connected) {
        await bluetoothRepository.disconnect();
        this.timeoutId = setTimeout(() => {
           bluetoothRepository.startPair();
        }, 500);

        return;
      }
      const device = this.deviceList[index];
      if (device) {
        this.status = 0;
        this.showConnectStatusPopup = true;
        //发送请求查询蓝牙设备名称
        this.hubName = device.serverName || device.name;
        console.log(`开始连接`);
        console.log(this.deviceList);

        await bluetoothRepository.connectDevice(device, true);
        this.status = 1;
        //保存设备当前蓝牙设备到store
        console.log(`连接成功`);
        console.log(this.deviceList);
        const connected = device.gatt.connected;
        const connectedDevice = {
          adData: device.adData,
          deviceClass: device.deviceClass,
          gatt: device.gatt,
          id: device.id,
          listeners: device.listeners,
          macAddress: device.macAddress,
          name: device.name,
          productId: device.productId,
          productVersion: device.productVersion,
          uuids: device.uuids,
          vendorId: device.vendorId,
          vendorIdSource: "bluetooth"
        };
        console.log(`connected = ${connected}`);
        this.$set(this.deviceList, index, connectedDevice);
        this.$store.commit("bluetooth/updateConnectedDevice", connectedDevice);
        setTimeout(() => {
          this.showConnectStatusPopup = false;
        }, 2000);
        this.connectTimeoutId = setTimeout(() => {
          if (!this.isConnected) {
            this.status = 2;
          }
        }, 10000);
      }
    },

    onClickDisconnectCancel() {
      // this.showDisconnectPopup = false;
    }
  },
  watch: {
    deviceList: {
      deep: true,
      handler: function(val) {

        console.log(`watch device list = ${JSON.stringify(val)}`);
      }
    }
  },
  computed: {
    ...mapState("bluetooth", ["deviceList", "isConnected"])
  },
  mounted() {
    console.log();
    bluetoothRepository.startPair();
  },
  destroyed() {
    clearTimeout(this.timeoutId)
    bluetoothRepository.cancelSearch();
  }
};
</script>


<style scoped lang="less">
.content {
  height: 100%;
  overflow-y: auto;
  background: #f6f6f6;
  padding: 16px 0;
}
</style>